import { render, staticRenderFns } from "./cAdminLevelling.vue?vue&type=template&id=1361945c&scoped=true"
import script from "./cAdminLevelling.vue?vue&type=script&setup=true&lang=js"
export * from "./cAdminLevelling.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cAdminLevelling.vue?vue&type=style&index=0&id=1361945c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1361945c",
  null
  
)

export default component.exports